import { z } from 'zod';

// Osoba v grafe prepojení (Blok 1) — identita je meno[+dátum narodenia], SK registre
// nezverejňujú rodné číslo (viď docs/02 Blok 1, známe obmedzenie zdieľané s Foaf/Finstat).
export const personSchema = z.object({
  id: z.string().uuid(),
  fullName: z.string(),
  givenNames: z.string().nullable(),
  familyNames: z.string().nullable(),
  birthDate: z.string().nullable(),
  fingerprint: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Person = z.infer<typeof personSchema>;
